module.exports = __webpack_public_path__ + "static/media/codioful-formerly-gradienta-9X6tbXe_bw4-unsplash.a9bad320.jpg";